module.exports = __webpack_public_path__ + "img/PGR_A02_front_en.e4525815.png";